import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import modalReducer from './modalSlice';
import cartReducer from './cartSlice';

export const store = configureStore({
  reducer: {
    auth:  authReducer,
    modal: modalReducer,
    cart:  cartReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
